const $ = require('jquery');

// Make it easier to use jQuery from the console
window.$ = $;

// required for ie compatability
require('./components/object-polyfill.js');
require('babel-polyfill');

// add our components
require('./components/jump-menu.js');
require('./components/button.js');
require('./components/form.js');
require('./components/hp-hero-button.js');
require('./components/header.js');
require('./components/translate.js');
require('./components/jquery-tabs.js');
require('./components/outbound-link.js');

// add page js
require('./pages/schedule/schedule.js');
require('./pages/trip-planner.js');
require('./pages/homepage.js');
require('./pages/contact.js');
require('./pages/why-i-ride.js');

console.log('Golden Routes December')